module.exports = __webpack_public_path__ + "static/media/appointment.c39b3f42.png";